import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getNationalMinorities } from "../../slices/codeBookSlice";

export const useGetNationalMinorities = () => {
  const nationalMinorities = useSelector(
    (state: RootState) => state.codeBook.nationalMinorities
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNationalMinorities());
  }, [dispatch]);

  return nationalMinorities;
};
